module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-dots-fill-507bdf22.svg";